export default __webpack_public_path__ + "static/media/discordLeave.84204d50.mp3";